<template>
<v-container fluid>
  <v-row class="mb-3" no-gutters>
      <h2 class="text-h4 mb-3">Running campaigns</h2>
      
      <v-spacer />
      <action-button
        @click="getCampaigns"
        :loading="loading"
        icon="$refresh"
        :tooltip="$t('campaigns.refresh')"
        fab
        small
      />
      
    </v-row>
  <v-alert v-if="!isHelpdesk" type="error">Not authorized</v-alert>
  <v-card v-else-if="rclist">
      <!--
    <v-card-text>
    <v-tabs v-model="tab">
    <v-tab>{{$t('campaigns.scheduled.list')}}</v-tab>
    <v-tab >{{$t('campaigns.automatic.list')}}</v-tab>
    <v-tab >{{$t('campaigns.btc.list')}}</v-tab>
    <v-tab >{{$t('campaigns.swu.list')}}</v-tab>
    </v-tabs>
    <v-tabs-items class="mt-2" v-model="tab">
    <v-tab-item>
    </v-tab-item>
    <v-tab-item>
    </v-tab-item>
    <v-tab-item>
    </v-tab-item>
    </v-tabs-items>
    </v-card-text>
    -->
    <v-card-text>
          <v-text-field
            :placeholder="$t('common.search')"
            v-model="search"
            prepend-icon="$search"
            clearable
          />
        </v-card-text>
    <v-data-table 
      :headers="headers" 
      sort-by="scheduleType"
      :items="rclist"
      sort-desc
      show-expand
      :items-per-page="-1"
      :search="search"
    >
        <template v-slot:[`item.scheduleType`]="i">
            <v-icon>{{ typeIconF(i.item.scheduleType)}}</v-icon>{{ campaignTypeF(i.item.scheduleType) }}
        </template>
       <template v-slot:[`item.name`]="i">
      <router-link :to="{ name: 'campaign-detail', params: {company: i.item.domain.companyID, domain: i.item.domain.id, campaign: i.item.id}}">{{ i.item.name }}</router-link>
    </template> 
        <template v-slot:[`item.state`]="i">
            <v-chip outlined :color="getCampaignStateColor(i.item.state)">
                {{ getCampaignStateText(i.item.state).toUpperCase() }}
            </v-chip>
        </template>

    <template v-slot:[`item.schedule`]="i">
      {{ formatDate(JSON.parse(i.item.schedule).start) }}
    </template>
    <template v-slot:[`item.lastMessage`]="i">
      {{ i.item.messages.items[0] ? (formatDate(i.item.messages.items[0].sent)+ ", " + (i.item.messages.items[0].visitor ? i.item.messages.items[0].visitor.email : i.item.messages.items[0].email)) : '-' }}
    </template>
    <template v-slot:[`item.messagesSent`]="i">
      {{ i.item.dailyStats.items[0] && i.item.dailyStats.items[0].date == today ? i.item.dailyStats.items[0].sent : '0' }}
    </template>
    <template v-slot:[`item.analysis`]="i">
      {{ analyzeState(i.item) }}
    </template>
    </v-data-table> 
    </v-card>
</v-container>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import Formatters from '@/mixins/formatters'
import CampaignFormatters from "@/mixins/campaign-formatters";

export default {
    name: 'RunningCampaigns',
    mixins: [Formatters, CampaignFormatters],
    data() {
        return {
            loading: false,
            search: null,
            tab: null,
            today: new Date().toISOString().substring(0,10),
            headers: [
                { text: this.$t('domains.name'), value: 'domain.name' },
                { text: this.$t('common.name'), value: 'name' },
                { text: this.$t('campaigns.type'), value: 'scheduleType' },
                { text: this.$t('common.state'), value: 'state' },
                { text: this.$t('campaigns.started'), value: 'schedule' },
                { text: this.$t('campaigns.lastMessage'), value: 'lastMessage'},
                { text: this.$t('campaigns.messagesSent'), value: 'messagesSent'},
                //{ text: this.$t('campaigns.analysis'), value: 'analysis'}
            ]
        }
    },
    computed: {
        ...mapState('helpdesk', ['rclist']),
        ...mapGetters("auth", ["isHelpdesk"]),
    },
    methods: {
        async getCampaigns() {
            this.loading = true;
            await this.$store.dispatch('helpdesk/getRunningCampaigns');
            await this.$store.dispatch('helpdesk/getRunningCampaigns', {append: true, state: 'WAITING'});
            this.loading = false;
        },
        analyzeState(c) {
            console.debug(c);
            return null;
        }
    },
    mounted() {
        this.getCampaigns();
    }
}
</script>